module.exports = __webpack_public_path__ + "static/media/background.5b8c0102.png";